/**
 * @generated SignedSource<<4a88cd5aefc8498e62acca813283b23f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TotalVotePowerRowFragment$data = {
  readonly totalTokensRepresented: {
    readonly amount: {
      readonly amount: string;
    };
  };
  readonly " $fragmentType": "TotalVotePowerRowFragment";
};
export type TotalVotePowerRowFragment$key = {
  readonly " $data"?: TotalVotePowerRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TotalVotePowerRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TotalVotePowerRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VotingPower",
      "kind": "LinkedField",
      "name": "totalTokensRepresented",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TokenAmount",
          "kind": "LinkedField",
          "name": "amount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "93c41bcadb0cd1ce39356a3dc5af7570";

export default node;
